import Loading from '../common/Loading.tsx';
import { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { DataLayerParameterValues, substituteParameters } from './Map.tsx';
import { DataLayerParameter } from '../api/api.ts';
import cn from '@/utils/cn.ts';

const {
  // VITE_MAPBOX_USERNAME: MAPBOX_USERNAME,
  // VITE_MAPBOX_STYLE_ID: MAPBOX_STYLE_ID,
  // VITE_MAPBOX_ACCESS_TOKEN: MAPBOX_ACCESS_TOKEN,
  VITE_BACKEND_BASE_URL: BACKEND_BASE_URL,
} = import.meta.env;

export default function Plot({
  url,
  parameterValues,
  parameters,
}: {
  url: string;
  parameterValues: DataLayerParameterValues;
  parameters: Record<string, DataLayerParameter>;
}) {
  const [loaded, setLoaded] = useState(false);

  const urlWithValues = useMemo(() => {
    return substituteParameters(url, parameterValues, parameters);
  }, [url, parameterValues]);

  const [delayedUrl, setDelayedUrl] = useState(urlWithValues);
  const delayTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setLoaded(false);
    if (delayTimer.current !== null) {
      clearTimeout(delayTimer.current);
      delayTimer.current = null;
    }
    delayTimer.current = setTimeout(() => {
      setDelayedUrl(urlWithValues);
    }, 2000);
  }, [urlWithValues]);
  return (
    <div
      className={cn(
        'absolute',
        'inset-0',
        'flex',
        'items-center',
        'justify-center'
      )}
    >
      {!loaded && <Loading size={1} center={true} />}
      <img
        className={cn(
          loaded ? 'block' : 'hidden',
          'w-full',
          'h-full',
          'object-contain'
        )}
        onLoad={() => {
          setLoaded(true);
        }}
        src={BACKEND_BASE_URL + delayedUrl}
        alt="plot"
      />
    </div>
  );
}
